import styled from 'styled-components';
import { MAIN_HEADING_FONT, COLOR_STREAM } from '../../../common/variables';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  > div {
    flex: 0 0 48%;
  }
`;
export const ImageContainer = styled.div`
  margin: 0;
  img {
    max-width: 500px;
    min-height: 500px;
  }
`;
export const TextContainer = styled.div`
  margin-top: 80px !important;

  h3{
    ${MAIN_HEADING_FONT}
    color: ${COLOR_STREAM};
    font-weight: 400;
    font-size: 1.5rem;
    min-height: 3.5rem;

  }
  p{
    font-weight: 300;
    color: #808080;
    margin-bottom:10px;
    margin-right:3rem;
    font-family: 'Source Sans Pro',Arial,Helvetica,sans-serif!important;
  }
  margin-top: 30px;
`;

export const StreamIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: -10px;
`;

export const StreamGroup = styled.span`
  cursor: pointer;
  display: flex;
  position: relative;
  padding: 10px;
  span,
  svg {
    pointer-events: none;
  }

  span {
    position: relative;
  }

  svg {
    width: 100%;
    max-width: 30px;
    height: 30px;
    padding: 5px;
  }
  &.inactive path {
    fill: ${COLOR_STREAM};
  }

  &:after {
    content: ' ';
    border-right: 2px solid rgb(102, 105, 133);
    width: 2px;
    height: 23px;
    position: absolute;
    top: 19px;
    right: 0;
    max-width: 2px;
  }
  &:last-child:after {
    content: none;
  }
`;
